module.exports = __webpack_public_path__ + "img/9788958283959.5f715041.jpg";